import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LandingNavbar.module.css';
import { FaArrowRight } from 'react-icons/fa';

const LandingNavbar = ({ showLoginButton = true, transparent = false }) => {
  return (
    <nav className={`${styles.navbar} ${transparent ? styles.transparent : ''}`}>
      <Link to="/" className={styles.navLogoLink} style={{ textDecoration: 'none' }}>
        <div className={styles.navLogo}>
          <img src="/img/logo-blanco-AI.png" alt="Atlas Investments" />
        </div>
      </Link>
      {showLoginButton ? (
        <Link to="/login" className={styles.loginBtn}>
          Employee Portal <FaArrowRight className={styles.icon} />
        </Link>
      ) : (
        <div style={{ padding: '0.75rem 1.5rem' }}></div>
      )}
    </nav>
  );
};

export default LandingNavbar;
